import Vue from 'vue'
import axios from 'axios'
import cfg from '@/cfg'

const API_URL = cfg.ACCOUNTS_API_URL

axios.defaults.withCredentials = true;

// `baseURL` is prepended to URLs passed to axios
axios.defaults.baseURL = API_URL

// POST with JSON content type
axios.defaults.headers.post['Content-Type'] = 'application/json'

// It gives you easy global access to it instead use import
Vue.prototype.$http = axios.create()

const getDefaultState = () => {
  return {
    Addresses: null
  }
}

// initial state
const state = getDefaultState()

export const getters = {
  Addresses: state => state.Addresses
}

export const actions = {
  ResetAddressesState (context) {
    context.commit('RESET_ADDRESSES_STATE')
  },
  FetchAddresses(context) {
    axios
    .get(cfg.ACCOUNTS_API_URL + "addresses", {withCredentials: true})
    .then((res) => {
      context.commit('SET_ADDRESSES', res.data)
    })
    .catch(() => {
      context.commit('SET_ADDRESSES', null)
    });
  }
}

export const mutations = {
  SET_ADDRESSES(state, payloda) {
    state.Addresses = payloda
  },
  RESET_ADDRESSES_STATE(state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
